// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._appSettingsSectionShortcuts_1trvh_2 {
	display: flex;
	flex-direction: column;
	gap: calc(4 * var(--default-grid-baseline));
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcAppSettingsShortcutsSection-CRO4RakN.css"],"names":[],"mappings":";AACA;CACC,aAAa;CACb,sBAAsB;CACtB,2CAA2C;AAC5C","sourcesContent":["\n._appSettingsSectionShortcuts_1trvh_2 {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: calc(4 * var(--default-grid-baseline));\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
